import { createStandardAction } from 'typesafe-actions';

import { FeedOrderUpdate } from '@tradingblock/types';

export const ORDER_UPDATERECEIVED = `@order/updated`;
export const OrderFeedActions = {
  receivedUpdate: createStandardAction(ORDER_UPDATERECEIVED)<{ order: FeedOrderUpdate }>(),
};
